/**
 * @author: dongjing
 * @file: description
 * @Date: 1985-10-26 16:15:00
 * @LastEditors: dongjing
 * @LastEditTime: 2019-12-13 21:13:41
 */
import { activeModelState } from './activeModel';

const initialState = {
  ...activeModelState
};

export type IInitialState = Readonly<typeof initialState>;

export default initialState;
